// extracted by mini-css-extract-plugin
export default {"loaderWrap":"Loader_loaderWrap__aFsRH","loaderImage":"Loader_loaderImage__yGZP1","pulse":"Loader_pulse__d7uaa"};